import {
  Boxes,
  ReceiptText,
  LayoutDashboard,
  Building2,
  UserRound,
} from "lucide-react";
import { LandingShell, Accent } from "./LandingShell";

/**
 * AMSaaS (B2B) marketing landing — shown at `/` on the amsaas.app host to signed-out
 * visitors. Two doors: Provider console + Client portal. App-branded blue (WL-03).
 */
const ACCENT = "#2563eb";
const ACCENT2 = "#0ea5e9";

export function AmsaasLandingPage(): JSX.Element {
  return (
    <LandingShell
      appName="AMSaaS"
      appTagline="Application Maintenance Services as a Service"
      logoSrc="/logos/amsaas-login-banner.png"
      logoSrc2x="/logos/amsaas-login-banner@2x.png"
      accent={ACCENT}
      accent2={ACCENT2}
      badge="🚀 New: online invoice payments"
      headline={
        <>
          Run your whole{" "}
          <Accent from={ACCENT} to={ACCENT2}>
            service business
          </Accent>{" "}
          from one console.
        </>
      }
      blurb="White-label catalogue, client onboarding, pro-rated invoicing and your team — ready the moment you sign in."
      stats={[
        { value: "120+", label: "Providers" },
        { value: "$4.2M", label: "Invoiced" },
        { value: "99.9%", label: "Uptime" },
        { value: "4.9/5", label: "Rating" },
      ]}
      features={[
        {
          icon: Boxes,
          title: "Service catalogue",
          blurb: "Services, add-ons, dimensions and pricing bands.",
        },
        {
          icon: ReceiptText,
          title: "Pro-rated billing",
          blurb: "Mid-cycle proration, PDFs and online payments.",
        },
        {
          icon: LayoutDashboard,
          title: "Client portal",
          blurb: "Clients self-serve subscriptions and invoices.",
        },
      ]}
      doors={[
        {
          href: "/login/provider",
          eyebrow: "Provider",
          title: "Provider sign-in",
          blurb: "Run your whole business from one white-labelled console.",
          bullets: [
            "Catalogue & pricing",
            "Clients & onboarding",
            "Billing & team",
          ],
          icon: Building2,
          primary: true,
        },
        {
          href: "/login/client",
          eyebrow: "Client",
          title: "Client sign-in",
          blurb: "See your services, subscriptions and invoices in one place.",
          bullets: [
            "Active subscriptions",
            "Download invoices",
            "Manage your team",
          ],
          icon: UserRound,
        },
      ]}
    />
  );
}
